<form *ngIf="formGroup" [formGroup]="formGroup">
	<app-form-field [type]="fields.title.type" [options]="fields.title.options"></app-form-field>
	<app-form-field [type]="fields.description.type" [options]="fields.description.options"></app-form-field>
	<app-form-field *ngIf="isAdmin" [type]="fields.client_id.type" [options]="fields.client_id.options"></app-form-field>
	<app-form-field [type]="fields.media_client_id.type" [options]="fields.media_client_id.options"></app-form-field>
	<app-form-field *ngIf="!data?.item.id" [type]="fields.resource.type" [options]="fields.resource.options"></app-form-field>

	<app-form-field [type]="fields.fecha.type" [options]="fields.fecha.options"></app-form-field>
	<app-form-field [type]="fields.vigencia.type" [options]="fields.vigencia.options"></app-form-field>
	<app-form-field [type]="fields.categories.type" [options]="fields.categories.options"></app-form-field>
	<app-form-field [type]="fields.reproducciones_contratadas.type" [options]="fields.reproducciones_contratadas.options"></app-form-field>

	<div class="modal-footer">
		<button class="btn btn-success" (click)="submit()"><i class="fa fa-save"></i> Guardar</button>
		<button class="btn btn-danger" (click)="modalRef.hide()"><i class="fa fa-times"></i> Cancelar</button>
	</div>
</form>
